import { useTranslation } from 'react-i18next'

import { URL_CHECKOUT } from '@shared/contants'
import { useLocalizedNavigate as useNavigate } from '@shared/lib/locale'
import Button from '@shared/ui/button'

export default function GoToCheckout () {
  const navigate = useNavigate()
  const { t: tc } = useTranslation('cart')

  const handleClick = async () => {
    navigate(URL_CHECKOUT)
  }

  return (
    <Button size="large" to={URL_CHECKOUT} onClick={handleClick}>
      {tc('total.checkout')}
    </Button>
  )
}
